const amznAdsStormLogo = {
  iconName: 'amzn-ads-storm-logo',
  prefix: 'fab',
  icon: [478, 512, [], '', 'M417.77 57.42c34.57 34.04 51.86 80.18 51.86 138.44 0 57.03-11.17 108.84-33.5 155.45-22.33 46.6-54 83.7-94.99 111.3-41 27.6-88.1 41.39-141.33 41.39-37.1 0-69.4-6.8-96.85-20.38l265.49-236.27-123.87-24.13 149.5-185.2a166.36 166.36 0 0 1 23.7 19.4ZM246.9 8 99.98 265.8l105.1 20.48L83.52 472.33a166.36 166.36 0 0 1-23.67-19.38C25.28 418.92 8 372.77 8 314.52c0-57.03 11.17-108.85 33.5-155.45 22.33-46.6 54-83.7 94.98-111.3C169.35 25.64 206.16 12.38 246.9 8Z']
};
const textSeparator = {
  prefix: 'far',
  iconName: 'text-separator',
  icon: [512, 512, [], '', 'M256 8a31 31 0 0 1 31 31v434a31 31 0 1 1-62 0V39a31 31 0 0 1 31-31Z']
};
const times = {
  prefix: 'fas',
  iconName: 'times',
  icon: [384, 512, [], '', 'M20.44 367.51a42.46 42.46 0 0 0 60.05 60.06L192 316.05l111.51 111.51a42.47 42.47 0 0 0 60.06-60.05L252.05 256l111.51-111.51a42.47 42.47 0 0 0-60.05-60.05L192 195.95 80.49 84.44a42.46 42.46 0 1 0-60.05 60.05L131.95 256 20.44 367.51Z']
};
const infoCircle = {
  prefix: 'fas',
  iconName: 'info-circle',
  icon: [512, 512, [], '', 'M256 8c136.97 0 248 111.03 248 248S392.97 504 256 504 8 392.97 8 256 119.03 8 256 8Zm31 201.5h-62v186a31 31 0 1 0 62 0v-186ZM256 70a46.5 46.5 0 1 0 0 93 46.5 46.5 0 0 0 0-93Z']
};
const angleInlineEnd = {
  prefix: 'fas',
  iconName: 'angle-inline-end',
  icon: [256, 512, [], '', 'M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z']
};
const angleInlineStart = {
  prefix: 'fas',
  iconName: 'angle-inline-start',
  icon: [256, 512, [], '', 'M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z']
};
const caretInlineEnd = {
  prefix: 'fas',
  iconName: 'caret-inline-end',
  icon: [192, 512, [], '', 'M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z']
};
const opportunities = {
  prefix: 'fas',
  iconName: 'opportunities',
  icon: [512, 512, [], '', 'M195.98 111.71a15.03 15.23 0 0 1 28.26-1.83l.6 1.83 6.76 21.02A228.8 231.77 0 0 0 371.56 278.9l5.26 1.98 20.6 6.85c13.37 4.57 13.97 23.15 1.8 28.94l-1.8.6-20.6 6.86A228.65 231.62 0 0 0 233.4 466.98l-1.8 5.33-6.77 21.01a15.03 15.23 0 0 1-28.11 1.83l-.75-1.83-6.77-21.01a228.5 231.46 0 0 0-139.8-146.2L44 324.15l-20.6-6.85c-13.23-4.57-13.83-23.15-1.65-28.94l1.65-.6 20.75-6.86a228.5 231.46 0 0 0 143.4-142.84l1.81-5.32 6.77-21.02Zm197.07-98.37a7.52 7.61 0 0 1 13.83-1.37l.6 1.37 3.31 10.5a114.4 115.88 0 0 0 68.55 72.64l4.21 1.53 10.22 3.35c6.47 2.28 6.92 11.11 1.36 14.16l-1.36.6-10.22 3.5a114.25 115.73 0 0 0-71.25 69.9l-1.5 4.12-3.31 10.66a7.52 7.61 0 0 1-13.83 1.21l-.6-1.37-3.46-10.5A114.25 115.73 0 0 0 321.2 121l-4.06-1.52-10.37-3.35c-6.47-2.14-6.92-11.12-1.36-14.17l1.36-.6L317.14 98a114.25 115.73 0 0 0 71.1-70.05l1.5-4.11 3.31-10.66Z']
};
const angleDoubleRight = {
  prefix: 'fas',
  iconName: 'angle-double-right',
  icon: [448, 512, [], '', 'M227.8 106.48a44.32 44.32 0 0 1 59.31-3.04l3.37 3.04L440 256 290.48 405.52a44.32 44.32 0 0 1-65.72-59.3l3.04-3.37L314.65 256l-86.85-86.84a44.32 44.32 0 0 1 0-62.68Zm-206.82 0a44.32 44.32 0 0 1 59.31-3.04l3.37 3.04L233.18 256 83.66 405.52a44.32 44.32 0 0 1-65.72-59.3l3.04-3.37L107.83 256l-86.85-86.84a44.32 44.32 0 0 1 0-62.68Z']
};
const angleDoubleLeft = {
  prefix: 'fas',
  iconName: 'angle-double-left',
  icon: [448, 512, [], '', 'M157.52 106.48a44.32 44.32 0 0 1 65.72 59.3l-3.04 3.38L133.35 256l86.85 86.85a44.32 44.32 0 0 1-59.31 65.71l-3.37-3.04L8 256l149.52-149.52Zm206.82 0a44.32 44.32 0 0 1 65.72 59.3l-3.04 3.38L340.17 256l86.85 86.85a44.32 44.32 0 0 1-59.31 65.71l-3.37-3.04L214.82 256l149.52-149.52Z']
};
const angleDown = {
  prefix: 'fas',
  iconName: 'angle-down',
  icon: [389, 512, [], '', 'M18.93 147.3a37.3 37.3 0 0 1 52.75 0L194.5 270.12 317.33 147.3a37.3 37.3 0 1 1 52.75 52.75L194.5 375.62 18.93 200.06a37.3 37.3 0 0 1 0-52.75Z']
};
const angleLeft = {
  prefix: 'fas',
  iconName: 'angle-left',
  icon: [256, 512, [], '', 'M237.04 79.88a37.42 37.42 0 0 1 0 52.91L113.84 256l123.2 123.2a37.42 37.42 0 0 1-52.91 52.93L8 256 184.13 79.87a37.42 37.42 0 0 1 52.91 0Z']
};
const angleRight = {
  prefix: 'fas',
  iconName: 'angle-right',
  icon: [256, 512, [], '', 'M18.96 432.13a37.42 37.42 0 0 1 0-52.92L142.16 256 18.97 132.78a37.42 37.42 0 0 1 52.91-52.91L248 256 71.87 432.13a37.42 37.42 0 0 1-52.91 0Z']
};
const angleUp = {
  prefix: 'fas',
  iconName: 'angle-up',
  icon: [389, 512, [], '', 'M370.08 364.7a37.3 37.3 0 0 1-52.76 0L194.5 241.88 71.67 364.7a37.3 37.3 0 1 1-52.75-52.75L194.5 136.38l175.58 175.57a37.3 37.3 0 0 1 0 52.75Z']
};
const calendarAlt = {
  prefix: 'fas',
  iconName: 'calendar-alt',
  icon: [448, 512, [], '', 'M332 40a27 27 0 0 1 27 27h27a54 54 0 0 1 54 54v297a54 54 0 0 1-54 54H62a54 54 0 0 1-54-54V121a54 54 0 0 1 54-54h27a27 27 0 1 1 54 0h162a27 27 0 0 1 27-27Zm54 148.5H62V418h324V188.5ZM156.5 310v54h-54v-54h54Zm94.5 0v54h-54v-54h54Zm94.5 0v54h-54v-54h54Zm-189-81v54h-54v-54h54Zm94.5 0v54h-54v-54h54Zm94.5 0v54h-54v-54h54Z']
};
const caretDown = {
  prefix: 'fas',
  iconName: 'caret-down',
  icon: [320, 512, [], '', 'M33.33 167.33a25.33 25.33 0 0 0-17.9 43.25l126.66 126.67a25.33 25.33 0 0 0 35.82 0l126.67-126.67a25.33 25.33 0 0 0-17.91-43.25H33.33Z']
};
const check = {
  prefix: 'fas',
  iconName: 'check',
  icon: [512, 512, [], '', 'M488.44 83.42a53.15 53.15 0 0 1 0 75.15L202.86 444.15l-179.3-179.3a53.14 53.14 0 0 1 75.16-75.15l104.14 104.14L413.28 83.42a53.15 53.15 0 0 1 75.16 0Z']
};
const clock = {
  prefix: 'far',
  iconName: 'clock',
  icon: [512, 512, [], '', 'M256 8c136.97 0 248 111.03 248 248S392.97 504 256 504 8 392.97 8 256 119.03 8 256 8Zm0 62C153.28 70 70 153.28 70 256c0 102.73 83.28 186 186 186 102.73 0 186-83.27 186-186 0-102.72-83.27-186-186-186Zm0 31a31 31 0 0 1 30.8 27.38l.2 3.62v93h93a31 31 0 0 1 3.62 61.8l-3.62.2H256a31 31 0 0 1-30.8-27.38L225 256V132a31 31 0 0 1 31-31Z']
};
const ellipsisV = {
  prefix: 'fas',
  iconName: 'ellipsis-v',
  icon: [192, 512, [], '', 'M96 132A62 62 0 1 0 96 8a62 62 0 0 0 0 124Zm62 124a62 62 0 1 1-124 0 62 62 0 0 1 124 0Zm0 186a62 62 0 1 1-124 0 62 62 0 0 1 124 0Z']
};
const exclamation = {
  prefix: 'fas',
  iconName: 'exclamation',
  icon: [192, 512, [], '', 'M158 442a62 62 0 1 1-124 0 62 62 0 0 1 124 0ZM96 8a62 62 0 0 1 62 62v217a62 62 0 1 1-124 0V70A62 62 0 0 1 96 8Z']
};
const exclamationTriangle = {
  prefix: 'fas',
  iconName: 'exclamation-triangle',
  icon: [576, 512, [], '', 'M288 8a49.6 49.6 0 0 1 40.24 20.6l2.6 4 231.47 396.8a49.6 49.6 0 0 1-38.04 74.37l-4.8.23H56.53a49.6 49.6 0 0 1-45.26-69.89l2.42-4.7L245.16 32.6A49.6 49.6 0 0 1 288 8Zm0 363.73a33.07 33.07 0 1 0 0 66.14 33.07 33.07 0 0 0 0-66.14Zm0-231.46a33.07 33.07 0 0 0-33.07 33.06V305.6a33.07 33.07 0 0 0 66.14 0V173.33A33.07 33.07 0 0 0 288 140.27Z']
};
const externalLinkAlt = {
  prefix: 'fas',
  iconName: 'external-link-alt',
  icon: [576, 512, [], '', 'M226 39a31 31 0 0 1 31-31h279v279a31 31 0 1 1-62 0V113.84L247.92 339.92a31 31 0 0 1-43.84-43.84L430.16 70H257a31 31 0 0 1-31-31ZM71 70a31 31 0 0 1 31 31v341h341a31 31 0 1 1 0 62H71a31 31 0 0 1-31-31V101a31 31 0 0 1 31-31Z']
};
const search = {
  prefix: 'fas',
  iconName: 'search',
  icon: [512, 512, [], '', 'M194 8c102.73 0 186 83.28 186 186 0 40.17-12.73 77.37-34.39 107.77l149.31 149.31a31 31 0 0 1-43.84 43.84l-149.3-149.3A185.14 185.14 0 0 1 194 380C91.28 380 8 296.73 8 194 8 91.28 91.28 8 194 8Zm0 62c-68.48 0-124 55.52-124 124 0 68.48 55.52 124 124 124 68.48 0 124-55.52 124-124 0-68.48-55.52-124-124-124Z']
};
const upload = {
  prefix: 'fas',
  iconName: 'upload',
  icon: [512, 512, [], '', 'M412.88 228.97a46.74 46.74 0 0 1-65.76 0L302.5 184.7v134.7c0 25.5-20.82 46.15-46.5 46.15s-46.5-20.65-46.5-46.15V184.7l-44.62 44.27a46.74 46.74 0 0 1-65.76 0 45.9 45.9 0 0 1 0-65.26L256 8l156.88 155.71a45.9 45.9 0 0 1 0 65.26ZM54.5 411.7C28.82 411.7 8 432.37 8 457.85 8 483.35 28.82 504 54.5 504h403c25.68 0 46.5-20.64 46.5-46.15 0-25.48-20.82-46.15-46.5-46.15h-403Z']
};
const ellipsisH = {
  prefix: 'fas',
  iconName: 'ellipsis-h',
  icon: [512, 512, [], '', 'M70 318a62 62 0 1 0 0-124 62 62 0 0 0 0 124Zm248-62a62 62 0 1 1-124 0 62 62 0 0 1 124 0Zm186 0a62 62 0 1 1-124 0 62 62 0 0 1 124 0Z']
};

export { exclamation as a, angleInlineEnd as b, check as c, ellipsisH as d, exclamationTriangle as e, angleUp as f, angleDown as g, caretDown as h, infoCircle as i, caretInlineEnd as j, externalLinkAlt as k, angleLeft as l, angleRight as m, amznAdsStormLogo as n, ellipsisV as o, angleDoubleLeft as p, angleDoubleRight as q, calendarAlt as r, search as s, times as t, upload as u, clock as v, opportunities as w, textSeparator as x, angleInlineStart as y };
//# sourceMappingURL=localIcons-889a4ef1-4d9affee.js.map
